import React, { memo } from 'react'

import { StatusTag } from '@components'
import { Tag } from '@fourthwall/components'

import type { Mode, OfferItem, SingleVariantOfferItem } from '../../SelectProductsModal.types'

type ItemStatusProps = {
  item: OfferItem | SingleVariantOfferItem
  mode: Mode
}

export const ProductsListItemStatus = memo(({ item, mode }: ItemStatusProps) => {
  if (mode === 'INVENTORY_SHIPMENT') {
    return item.hasHsCode ? null : (
      <Tag
        appearance="alert"
        label="Product category required"
        tooltip="Product category required"
      />
    )
  }

  return <StatusTag status={item.state} isSoldOut={!item.available} />
})
